import React, { memo, forwardRef } from 'react'
import { util } from '../../../util'

const TableRow = ({ hover, selected, className, children }, ref) => {
    return (
        <tr
            ref={ref}
            data-testid={'table-row'}
            className={util.joinClasses(
                'table-row',
                hover,
                selected && 'table-row__selected',
                className
            )}
        >
            {children}
        </tr>
    )
}

export default memo(forwardRef(TableRow))
